import { V_FORM_ENUM } from "@/CommonDP/VForm/utils";
const COMPONENT_ENUM = {
  TYPE: "custom-sub-form",
  LABEL: "关联单行子表单"
};

export const schema = {
  group: V_FORM_ENUM.container,
  type: COMPONENT_ENUM.TYPE, // 唯一名称
  icon: "sub-form",
  label: COMPONENT_ENUM.LABEL,
  category: "container", // 容器组件必须设置为'container'；
  widgetList: [], // 容器内存放的组件列表，初始值必须为[]
  component: require("./customSubFormWidget.vue").default,
  renderComponent: require("./customSubFormItem.vue").default,
  options: { // 组件属性对象，每一个属性值对应一个属性编辑器。
    name: '',
    label: "",
    sublist: "",
    fieldNum: 88888,
    requiredHint: ' ',
    onValidate: "",
    gridMaxHeight: '',
    labelHidden: false,
    labelWrap: false, // 自动换行
    labelWidth: 80,
    labelAlign: 'label-center-align',
    showBlankRow: true,
    showRowNumber: true,
    hidden: false,
    disabled: false,
    fixedNum: 0,
    actionColumnPosition: 'left', // 操作按钮列位置
    customClass: '', // 自定义css类名
    onSubFormRowAdd: '',
    onSubFormRowInsert: '',
    onSubFormRowDelete: '',
    onSubFormRowChange: '',
    updateCellState: "",
    updateRowState: ""
  },
  props() {
    return {
      sublist: () => import("./sublist.vue")
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ["value"],
      updateCellState: ["fieldName", "row", "list", "component"],
      updateRowState: ["row", "list"]
    };
  },
  getSFC: () => {
    return "<div></div>";
  },
  zh: {
    [COMPONENT_ENUM.TYPE]: {
      label: "标签名称"
    }
  }
};
